import Link from 'next/link';
import { Notification } from '@/hooks/useNotifications';
import { FaCircle, FaInfoCircle, FaShoppingBag, FaChalkboardTeacher, FaBullhorn } from 'react-icons/fa';

interface NotificationItemProps {
    notification: Notification;
    onRead: (id: string) => void;
}

const getIcon = (type: string) => {
    switch (type) {
        case 'order':
            return <FaShoppingBag className="text-blue-500" />;
        case 'course':
            return <FaChalkboardTeacher className="text-green-500" />;
        case 'system':
            return <FaBullhorn className="text-orange-500" />;
        default:
            return <FaInfoCircle className="text-gray-500" />;
    }
};

export default function NotificationItem({ notification, onRead }: NotificationItemProps) {
    const handleClick = () => {
        if (!notification.is_read) {
            onRead(notification.id);
        }
    };

    const Content = (
        <div
            className={`flex items-start p-3 border-b hover:bg-gray-50 transition-colors cursor-pointer ${!notification.is_read ? 'bg-blue-50' : 'bg-white'}`}
            onClick={handleClick}
        >
            <div className="mt-1 mr-3 flex-shrink-0">
                {getIcon(notification.type)}
            </div>
            <div className="flex-1 min-w-0">
                <div className="flex justify-between items-baseline">
                    <p className={`text-sm font-medium truncate ${!notification.is_read ? 'text-gray-900' : 'text-gray-600'}`}>
                        {notification.title}
                    </p>
                    {!notification.is_read && (
                        <FaCircle className="w-2 h-2 text-blue-600 ml-2 flex-shrink-0" />
                    )}
                </div>
                <p className="text-sm text-gray-500 line-clamp-2 mt-0.5">
                    {notification.content}
                </p>
                <p className="text-xs text-gray-400 mt-1">
                    {new Date(notification.created_at).toLocaleString()}
                </p>
            </div>
        </div>
    );

    if (notification.link) {
        return (
            <Link href={notification.link} onClick={handleClick}>
                {Content}
            </Link>
        );
    }

    return Content;
}
